import React, { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, Alert } from "@mui/material";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import HttpService from "../services/HttpService";

export default function SupersetEmbeddedDashboard({
  dashboardId,
  height = "600px",
}) {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const id = dashboardId || window.SUPERSET_DASHBOARD_ID;
  const supersetDomain = window.SUPERSET_URL;

  useEffect(() => {
    if (!id || !supersetDomain || !containerRef.current) return;

    let unmount;

    async function fetchGuestToken() {
      const response = await HttpService.getAxiosClient().get(
        window.API_URL + `/dashboard/guest-token?dashboardId=${id}`
      );
      return response.data.token;
    }

    embedDashboard({
      id,
      supersetDomain,
      mountPoint: containerRef.current,
      fetchGuestToken,
      dashboardUiConfig: {
        hideTitle: true,
        filters: { visible: true },
      },
    })
      .then((embedded) => {
        unmount = embedded.unmount;
        setLoading(false);
      })
      .catch((err) => {
        console.error("Superset embed error:", err);
        setError("Failed to load dashboard.");
        setLoading(false);
      });

    return () => {
      if (unmount) unmount();
    };
  }, [id, supersetDomain]);

  if (!id || !supersetDomain) {
    return null;
  }

  return (
    <Box position="relative" width="100%" height={height}>
      {loading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      )}
      {error && <Alert severity="error">{error}</Alert>}
      <Box
        ref={containerRef}
        width="100%"
        height="100%"
        sx={{
          "& iframe": {
            width: "100%",
            height: "100%",
            border: "none",
          },
        }}
      />
    </Box>
  );
}
